import React, { PureComponent } from 'react'
import T from 'prop-types'
// import _ from 'lodash'
import IT from 'react-immutable-proptypes'
import {
  // TextInput,
  ScrollBars,
  // CircleLoader,
  AnimateHeight,
  SaveButton,
  ErrorState,
  DataTable,
  // Button
  DimensionAware,
  TextOverflowCenterLite
} from 'react-base'
import {
  is,
  Map,
  List,
  OrderedMap,
  Iterable
} from 'immutable'
import {
  SCHEMA_ITEM_SHAPE,
  SCHEMA_SHAPE
} from '../shapes'

export default class DefaultRowHeaderCell extends PureComponent {
  static propTypes = {
    rowIndex: T.number,
    rowKey: T.oneOfType([T.string, T.number]).isRequired,
    schema: SCHEMA_SHAPE.isRequired,
    row: IT.map,
    isSticky: T.bool,
    onStickyChange: T.func,
    canBeStickied: T.bool,
    isOrigin: T.bool, // If true, this is the top-left origin (row and column header)
    rowHeaderComponent: T.oneOfType([T.element, T.func]), // React Component or Functional/Stateless component
    rowHeaderComponentProps: IT.mapOf(T.any, T.string),
  }

  static defaultProps = {
    canBeStickied: true
  }

  handleStickyBtnClick = () => {
    this.props.onStickyChange(this.props.rowKey)
  }

  render() {
    const {
      row,
      schema,
      rowIndex,
      rowKey,
      isSticky,
      canBeStickied,
      rowHeaderComponent,
      rowHeaderComponentProps
    } = this.props

    const RowHeaderComponent = rowHeaderComponent
    const defaultContent = `${rowIndex + 1}`

    return (
      <div
        className={`schemer_row_header_cell_content`}
      >
        <div className={`header_buttons`}>
          {canBeStickied &&
            <span
              className={`btn btn-icon icon-pushpin sticky_btn ${isSticky ? 'is_stickyable' : ''}`}
              onClick={this.handleStickyBtnClick}
            />
          }
        </div>
        <div>
          {RowHeaderComponent ? (
            <RowHeaderComponent
              row={row}
              rowIndex={rowIndex}
              rowKey={rowKey}
              schema={schema}
              {...(rowHeaderComponentProps ? rowHeaderComponentProps.toObject() : {})}
            />
          ) : typeof defaultContent === 'string' ? (
            <TextOverflowCenterLite
              value={defaultContent}
            />
          ) : defaultContent}
        </div>
      </div>
    )
  }

}